import { useContext } from "react";
import { BrandingContext } from "./BrandingProvider";

export const useBranding = () => {
  const branding = useContext(BrandingContext);
  return branding;
};
